import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
} from "@mui/material";
import "../campaigns/Campaigns.scss";
import CloseIcon from '../../assets/icons/close-icon-black.svg';

interface DialogEditProps {
    open: boolean;
    onClose: () => void;
    onEdit: () => void;
    id?: string | number | null;
    name: string;
    status: string;
}

const DialogEdit = ({
    open,
    onClose,
    onEdit,
    id,
    name,
    status
  }: DialogEditProps) => {

    return (
        <Dialog open={open} onClose={onClose} className="general-dialog">
            <DialogTitle className="custom-dialog-title">
                <div className="view-all-attributes__title">Editing an active campaign</div>
                <img className='close-icon' src={CloseIcon} alt='close icon' onClick={onClose} />
            </DialogTitle>
            <DialogContent className="dialog-download">
                <div className='dataset-sec'>
                    <div className='view-all-attributes__dataset-wrapper__label'>
                        This campaign is active. Editing may impact its performance.
                        <b>&nbsp;Please confirm that you want to continue.</b></div>
                </div>
            </DialogContent>
            <DialogActions>
                <button type="button" className="btn-border" onClick={onClose}>
                    Cancel
                </button>
                <button type="button" className="btn-primary" onClick={onEdit}>
                    Edit Anyway
                </button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogEdit;